export enum ExpandIconPosition {
  START = 'start',
  END = 'end'
}
